import { memo, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import { isForcedLogin, isLoginPopupInitiallyOpen, isLoginTimeoutErrorVisible } from "~/features/auth/login/loginUtils";
import ToastMessage from "~/common/components/Messages/ToastMessage/ToastMessage";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/mui";
import { openAuthOverlay } from "~/features/registration/components/redux/AuthActions";
import { useAppConfig } from "~/app/config/useAppConfig";

export const HeaderLoginElement = memo(() => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const forceLogin = useAppConfig()?.configuration.forceLoginPopup ?? false;
  const { val: resetPopupOpen, setFalse: closeReset } = useBooleanState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("reset")?.toLowerCase() === "true";
  });

  useEffect(() => {
    if (!resetPopupOpen && (isLoginPopupInitiallyOpen() || isForcedLogin(forceLogin))) {
      dispatch(openAuthOverlay("login"));
    }
  }, [dispatch, forceLogin, resetPopupOpen]);

  return (
    <>
      <Button sx={{ textTransform: "capitalize" }} onClick={() => dispatch(openAuthOverlay("login"))}>
        {t("feature.guestCheckout.login.loginBtn")}
      </Button>

      {isLoginTimeoutErrorVisible() && <ToastMessage type={"info"}>{t("login.error.timeout")}</ToastMessage>}
    </>
  );
});
